import { Token } from '@frontend/authentication-v2';
import { TextInput } from '@frontend/components/basic-forms';
import { DeviceSelectV2 } from '@frontend/device/select';
import { Device } from '@frontend/device/types';
import { LuArrowDown, LuArrowUp, LuCopy } from 'react-icons/lu';

import { IoTTab } from '../../app';
import useQrReader from './qr-reader.controller';

const ID = 'qr-reader';
export interface QrReaderProps {
    token: Token;
    iot: IoTTab;
    devices: Device[];
}

const QrReader = (props: QrReaderProps) => {
    const viewProps = useQrReader(props);

    return (
        <div id={ID}>
            <div className='card'>
                <div className='card-header flex items-center justify-between'>
                    <h4 className='mb-0'>QR Reader Emulator</h4>
                </div>
                <div className='card-body flex flex-col gap-4'>
                    <div className='flex flex-row items-end gap-2'>
                        {viewProps.relevantDevices.length > 1 && (
                            <DeviceSelectV2
                                value={viewProps.selectedDevice?.id}
                                onChangeObject={viewProps.setSelectedDevice}
                                subset={viewProps.relevantDevices.map((d) => d.id)}
                                hideLabel
                            />
                        )}
                        <TextInput
                            value={viewProps.qr}
                            onChange={viewProps.setQR}
                        />
                        <button
                            className='btn btn-brand-primary mb-0'
                            onClick={viewProps.scanCode}>
                            Send
                        </button>
                    </div>

                    <div>
                        <p className='text-brand-muted mb-2 text-xs font-semibold tracking-wider uppercase'>Received Messages</p>
                        {viewProps.messages.length === 0 ? (
                            <p className='text-brand-muted text-sm'>No messages received yet.</p>
                        ) : (
                            <div className='max-h-[30vh] overflow-y-auto'>
                                {viewProps.messages.map((msg, index) => (
                                    <div
                                        className='border-border-default hover:bg-background-default flex flex-row items-center gap-3 border-b px-2 py-1.5 last:border-0'
                                        key={index}>
                                        <span className='shrink-0'>
                                            {msg.incoming ? <LuArrowDown className='text-status-danger' /> : <LuArrowUp className='text-status-success' />}
                                        </span>
                                        <span className='text-brand-muted shrink-0 font-mono text-xs'>{msg.timestamp}</span>
                                        <span className='shrink-0 text-sm font-medium'>{msg.message}</span>
                                        <span className='text-brand-muted min-w-0 truncate text-sm'>{msg.info}</span>
                                        <LuCopy
                                            className='text-brand-muted hover:text-brand-primary ml-auto shrink-0 cursor-pointer'
                                            onClick={() => {
                                                navigator.clipboard.writeText(JSON.stringify(msg.data, null, 2));
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QrReader;
